export const removeLoggedUser = () => {
  localStorage.removeItem('LoggedUser');
  localStorage.removeItem('selectedGroup');
};
